// extracted by mini-css-extract-plugin
export default {"asset_content":"Asset_asset_content__SZRpC","asset_url":"Asset_asset_url__MnywG","svg_container":"Asset_svg_container__Nrryh"};